import _ from 'lodash';
import REST from '../rest';

const ENDPOINT = 'api/v1/categories';
const MAX_ITEMS = 100;

const queryParams = (params = {}) => {
  const paramsCopy = { ...params, page: { number: 1, size: MAX_ITEMS } };

  if (_.isString(params.reportSearch) && !_.isEmpty(params.reportSearch)) {
    Object.assign(paramsCopy, { report_search: paramsCopy.reportSearch });
    delete paramsCopy.reportSearch;
  }

  return paramsCopy;
};

export const load = (params) => REST.get(ENDPOINT, _.get(params, 'id'), queryParams(params));
export default 'load';
